module.exports = "/_next/static/images/clock-monotone-753d9b1043c3db2420e8bc8bf3239235.svg";